module.exports = __webpack_public_path__ + "assets/img/header1.a7e0deaa.png";